import React from 'react';

import { useDisclosure } from 'Util/Hooks';

import ClearExitConfirmationModalView from '../Components/ClearExitConfirmationModal';
import ClearModalView from '../Components/ClearModal';

const ClearExitConfirmModal = ({ children, muiProps }) => {
  const [isOpenExitConfirm, openExitConfirmModal, closeExitConfirmModal] = useDisclosure();
  const { onClose: onCloseClearModal, isActive: shouldActive, ...restMuiProps } = muiProps;

  const handleConfirmExit = () => {
    onCloseClearModal();
    closeExitConfirmModal();
  };

  return (
    <>
      <ClearModalView
        muiProps={{
          isActive: shouldActive,
          onClose: openExitConfirmModal,
          isControlled: true,
          ...restMuiProps,
        }}
      >
        {children}
      </ClearModalView>

      <ClearExitConfirmationModalView
        muiProps={{ isActive: isOpenExitConfirm }}
        onConfirm={handleConfirmExit}
        onCancel={closeExitConfirmModal}
      />
    </>
  );
};

ClearExitConfirmModal.propTypes = {
  ...ClearModalView.propTypes,
};

export default ClearExitConfirmModal;
